import styled from "styled-components"
import Typography from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import Img from "gatsby-image"

export const SectionContainer = styled.div`
  padding-top: 64px;
  @media (min-width: ${Breakpoints.md}) {
    padding-top: 80px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding-top: 96px;
  }
  color: var(--naval);
`

export const BackgroundContainer = styled.div`
  overflow: hidden;

  grid-column: 1 / -1;
  grid-row: 3 / 5;
  z-index: -10;
  position: relative;
  height: 106.6vw;
  width: 100vw;
  /* makes image full-bleed */
  margin-left: calc(50% - 50vw);

  ::before {
    content: " ";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 62.9%
    );
    z-index: 10;
  }

  @media (min-width: ${Breakpoints.md}) {
    height: 58.3vw;
  }
`

export const Background = styled(Img)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  max-height: 100%;
`

export const Title = styled.h2`
  grid-column: 2 / -2;
  grid-row: 1;
  text-align: center;
  ${Typography.mobileTextStyles.MobileHeadingTwoSemiBold}

  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingTwoSemiBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
  }
`

export const Description = styled.p`
  ${Typography.mobileTextStyles.MobileBodyRegular}
  color: var(--body-text-grey);
  grid-column: 2 / -2;
  grid-row: 2;
  text-align: center;
  margin-top: 24px;

  & > br {
    display: none;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletBodyRegular}
    & > br {
      display: initial;
    }
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
    ${Typography.desktopTextStyles.BodyText18}
  }
`

export const LinkContainer = styled.div`
  justify-self: center;
  grid-column: 1 / -1;
  grid-row: 3;
  margin-top: 32px;
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 64px;
  }
`
